// @flow
import get from 'lodash/get';
import type { User } from '../../../types/User';

export default function isAnonymousUser(user: User) {
  const userID = get(user, 'id');
  if (userID === '2' || userID === 2) {
    return true;
  }
  return false;
}
